var React = require('react');

function Resume (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"28","cy":"28","r":"28","fill":"#9646C3","key":0}),React.createElement("g",{"key":1},React.createElement("path",{"d":"M36.4,26.9l-14.8-9.6c-1.2-0.7-3.1,0-3.1,1.9v19.3c0,1.8,1.8,2.8,3.1,1.9l14.8-9.6 C37.6,29.9,37.6,27.8,36.4,26.9L36.4,26.9z","fill":"#FFFFFF"}))]);
}

Resume.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = Resume;

Resume.default = Resume;
